import axios from "axios";
import { FormEvent } from "react";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { ICelularNomeStore } from "..";

import { IConsultaCelular } from "../../../interface/celular";

export interface ICelularNomeModuleStore {
  resultadoCelularNome: IConsultaCelular[] | null;
  consultaCelularNome(
    url: string,
    nome: string | undefined,
    e?: FormEvent
  ): Promise<void>;
  limparConsultaCelularNome(): void;
}

export default (set: SetState<ICelularNomeStore>) =>
  ({
    resultadoCelularNome: null,
    async consultaCelularNome(url, nome, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));

        if (nome === "") {
          toast.error("Preencha o campo!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        } else {
          const response = await axios.get(
            `${url}/wsAlertaCel/BuscarPorNome/${nome}`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            }
          );

          if (response.status === 200) {
            set((state) => ({
              ...state,
              global: {
                ...state.global,
                loading: false,
              },
              celular: {
                ...state.celular,
                resultadoCelularNome: response.data.USUARIOS,
              },
            }));
          }
          if (response.status === 400) {
            toast.error(`${response.data}`, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 401) {
            toast.error(
              "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
            // logout()
          }
          if (response.status === 404) {
            set((state) => ({
              celular: {
                ...state.celular,
                resultadoCelular: null,
                mensagemCelular: response.data,
              },
            }));
          }
          if (response.status === 500 || response.status === 503) {
            toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
            return;
          }
          if (response.status === 504) {
            toast.error(
              "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
            return;
          }
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparConsultaCelularNome() {
      set((state) => ({
        ...state,
        celular: {
          ...state.celular,
          resultadoCelularNome: null,
          mensagemCelular: undefined,
        },
      }));
    },
  } as ICelularNomeModuleStore);
